/* eslint-disable jsx-a11y/alt-text */
//#region Components
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import FoundBlock from "./components/FoundBlock/FoundBlock";
//#endregion
//#region Icons
import searchIcon from "img/search_icon.svg";
//#endregion
//#region Styles
import { Container } from "./styles";
//#endregion
//#region Utils
import usePrevious from "utils/hooks/usePrevious";
//#endregion

const CustomSearchInput = ({
    disabled, alignItem, 
    label, placeholder, 
    dataFound, onBlur, 
    getText, selectDataItem, 
    foundItemText, 
    handlerItemSearched, 
    positionFoundBlock, 
    maxLength, show, width
}) => {
    const prevShow = usePrevious(show);
    return (
        <Container 
            width={width}
            ref={el => { 
                if (show && !prevShow && el) 
                    el.querySelector("input").focus();
            }}
            onBlur={() => {
                if (!onBlur) return;
                setTimeout(onBlur, 500);
            }}>
            <CustomTextInput
                label={label}
                value={foundItemText}
                onChange={handlerItemSearched}
                placeholder={placeholder}
                maxLength={maxLength}
                iconAdornment={<img src={searchIcon} alt="Ícono de búsqueda UTP"/>}
                disabled={disabled}/>
            <FoundBlock 
                alignItem={alignItem}
                dataFound={dataFound}
                onClick={selectDataItem}
                getText={getText}
                positionFoundBlock={positionFoundBlock}/>
        </Container>
    );
}

export default CustomSearchInput;